export default {
  WorkOrders: 'WorkOrders',
  BreakdownCase: 'BreakdownCase',
  Kitting: 'Kitting',
  KittingBeta: 'KittingBeta',
  DeKitting: 'DeKitting',
  Disposal: 'Disposal',
  KittingFlow: 'KittingFlow',
  KittingBetaReadOnly: 'KittingBetaReadOnly',
  KittingBetaEditOrder: 'KittingBetaEditOrder'
}
